import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { leaseFeePaymentCycleNameConfig } from './LeaseFeePaymentCycle.name';

enum LeaseFeePaymentCycle {
  everyMonthly = '1',
  everyTwoMonths = '2',
  everyThreeMonths = '3',
  everyFourMonths = '4',
  semiannually = '5',
  annually = '6',
}

const leaseFeePaymentCycleMap = new Map([
  ['1', LeaseFeePaymentCycle.everyMonthly],
  ['2', LeaseFeePaymentCycle.everyTwoMonths],
  ['3', LeaseFeePaymentCycle.everyThreeMonths],
  ['4', LeaseFeePaymentCycle.everyFourMonths],
  ['5', LeaseFeePaymentCycle.semiannually],
  ['6', LeaseFeePaymentCycle.annually],
]);

const rawValueToLeaseFeePaymentCycle = rawValueToEnumWithDefault(
  leaseFeePaymentCycleMap,
  LeaseFeePaymentCycle.everyMonthly,
);

const leaseFeePaymentCycleToDisplay = enumToNameWithDefault(
  LeaseFeePaymentCycle,
  leaseFeePaymentCycleNameConfig,
);

const leaseFeePaymentCycleToDisplayWithPrefix = enumToNameWithDefault(
  LeaseFeePaymentCycle,
  leaseFeePaymentCycleNameConfig,
  true,
);

export {
  LeaseFeePaymentCycle,
  leaseFeePaymentCycleToDisplay,
  leaseFeePaymentCycleToDisplayWithPrefix,
  rawValueToLeaseFeePaymentCycle,
};
